<template>
  <div class="play-video-page page">
    <div class="top-bar">
      <button type="button" class="back-btn" @click="back">
        <van-icon name="arrow-left" />
      </button>
      <div class="top-title">{{ $t("video.video") }}</div>
      <div class="top-placeholder"></div>
    </div>

    <div class="content-shell">
      <div class="player-shell">
        <video id="my-video" class="video-js"></video>
      </div>

      <div class="video-info">
        <div class="video-name">{{ videoInfo.vod_name }}</div>
        <div class="video-meta">{{ videoInfo.count || 0 }}{{ $t("video.num_play") }}</div>
      </div>

      <div class="section-title">{{ $t("index.recmonmand") }}</div>

      <div class="video-grid">
        <div
          v-for="item in moreVideoList"
          :key="item.id"
          class="video-card"
          @click="toPlayVideo(item.id)"
        >
          <div class="thumb-wrap">
            <img :src="item.vod_pic" :alt="item.vod_name" class="thumb-img" />
          </div>
          <div class="video-title">{{ item.vod_name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
import { normalizeMediaUrl } from "../../utils/media";

export default {
  data() {
    return {
      nowPlayVideoUrl: "",
      cover: "",
      userInfo: [],
      videoInfo: {},
      moreVideoInfo: [],
      player: null,
      is_play: false,
      times: null,
      is_see: 0,
    };
  },
  computed: {
    moreVideoList() {
      return Array.isArray(this.moreVideoInfo) ? this.moreVideoInfo : [];
    },
  },
  methods: {
    back() {
      this.$router.push({ path: "/Video" });
    },
    getVideoInfo() {
      this.$http({
        method: "get",
        data: { id: this.$route.query.id },
        url: "video_get_info",
      }).then((res) => {
        this.videoInfo = res.data || {};
        this.videoInfo.vod_pic = normalizeMediaUrl(this.videoInfo.vod_pic);
        this.videoInfo.vod_play_url = normalizeMediaUrl(this.videoInfo.vod_play_url);
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url || "";
        this.cover = this.videoInfo.vod_pic || "";
        const video = document.getElementById("my-video");
        if (video) {
          video.poster = this.cover;
        }
        this.getVideo();
      });
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
        return;
      }
      this.$router.push({ path: "/PlayVideo", query: { id } });
      window.location.reload();
    },
    getMoreVideoItem() {
      this.$http({
        method: "get",
        url: "video_get_more_item",
      }).then((res) => {
        this.moreVideoInfo = (res.data || []).map((item) => ({
          ...item,
          vod_pic: normalizeMediaUrl(item.vod_pic),
          vod_play_url: normalizeMediaUrl(item.vod_play_url),
        }));
      });
    },
    getVideo() {
      if (!this.player || !this.nowPlayVideoUrl) {
        return;
      }
      this.player.src([
        {
          src: this.nowPlayVideoUrl,
          type: "application/x-mpegURL",
        },
      ]);
      this.player.poster(this.cover);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.is_see = this.userInfo.is_see;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear();
            this.$router.push({ path: "/Login" });
          } else {
            this.getVideoInfo();
            this.getMoreVideoItem();
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  mounted() {
    const _this = this;
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
      return;
    }

    this.player = videojs(
      "my-video",
      {
        height: "200px",
        preload: "auto",
        controls: true,
        multipleArray: [0.75, 1, 1.5, 2],
      },
      function () {
        this.on("play", () => {
          _this.is_play = true;
        });
      }
    );

    this.getUserInfo();
    this.times = setInterval(() => {
      if (this.is_play && this.is_see == 0) {
        const ct = Math.round(this.player.currentTime());
        if (ct >= 180) {
          this.player.pause();
          this.$toast(this.$t("video.buy"));
        }
      }
    }, 2000);
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
    this.is_play = false;
    clearInterval(this.times);
  },
};
</script>

<style scoped>
.play-video-page {
  min-height: 100%;
  background: #f4f4f4;
  padding-bottom: 24px;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 84px;
  padding: 0 10px;
  background: #fff;
  border-bottom: 1px solid #ededed;
}

.back-btn,
.top-placeholder {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.back-btn {
  padding: 0;
  border: none;
  background: transparent;
  color: #222;
}

.back-btn .van-icon {
  font-size: 24px;
}

.top-title {
  color: #111;
  font-size: 22px;
  line-height: 30px;
  font-weight: 500;
  letter-spacing: 1px;
}

.content-shell {
  width: calc(100% - 30px);
  margin: 16px auto 0;
  padding: 14px 12px 18px;
  background: #fff;
  border: 1px solid #efefef;
  border-radius: 4px;
  box-sizing: border-box;
}

.player-shell {
  overflow: hidden;
  border-radius: 14px;
  background: #000;
}

.video-js {
  width: 100%;
  min-height: 210px;
  font-size: 16px;
}

.video-info {
  padding: 14px 2px 4px;
}

.video-name {
  color: #1b1b1b;
  font-size: 15px;
  line-height: 22px;
  font-weight: 600;
  word-break: break-word;
}

.video-meta {
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  color: #8e46d9;
  font-size: 12px;
  line-height: 18px;
  border-radius: 999px;
  background: #f5f3fa;
}

.section-title {
  margin: 8px 2px 14px;
  color: #1b1b1b;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 14px;
}

.video-card {
  min-width: 0;
}

.thumb-wrap {
  width: 100%;
  aspect-ratio: 1.78 / 1;
  overflow: hidden;
  border-radius: 14px;
  background: #eee;
}

.thumb-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.video-title {
  margin-top: 8px;
  color: #1b1b1b;
  font-size: 12px;
  line-height: 18px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 36px;
}

::v-deep .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  width: 68px;
  height: 46px;
  margin-left: -34px;
  margin-top: -23px;
  border: none;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.55);
}

::v-deep .video-js .vjs-control-bar {
  font-size: 12px;
}
</style>
